export const getWeekModeStartEnd = ({
  selectedWeek,
  weekStartsOn,
}: {
  selectedWeek: DateTime
  weekStartsOn: 'monday' | 'sunday'
}) => {
  // if selected week matches the start of the week, return the start and end of that week
  if (
    (selectedWeek.weekday === 1 && weekStartsOn === 'monday') ||
    (selectedWeek.weekday === 7 && weekStartsOn === 'sunday')
  ) {
    return {
      start: selectedWeek,
      end: selectedWeek.plus({ days: 6 }),
    }
  }

  const start = selectedWeek.plus({ day: weekStartsOn === 'monday' ? 1 : -1 })
  return { start: start, end: start.plus({ days: 6 }) }
}
